<template>
    <v-dialog lazy :max-width="$vuetify.breakpoint.smAndDown ? '95%' : '50%'" v-model="showModal">
        <v-card v-if="showModal">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="secondary"
                        fab
                        small
                        @click.stop="showModal = false"
                >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-text>
                <v-card-text>
                    <h4 class="pb-2">Kunden aus der Schweiz sparen sich ca. 12% - Wie das geht? Hier die Infos.</h4>
                    <h4 class="pb-2">Abholservice in Dornbirn – Vorteil KEINE Verzollung</h4>

                    <div class="pb-2">
                        Bequem online bestellen, bezahlten und sofort bei uns im Shop abholen. So haben Sie die Ware
                        schnellstmöglich bei Ihnen zuhause.
                    </div>

                    <div class="pb-2">
                        Mit der Rechnung beim österreichischen Zoll die Ausfuhr machen (Rechnung beim Österreichischen
                        Zoll abstempeln lassen und beim Schweizer Zoll die 8,1% Mehrwertsteuer zahlen), anschließend
                        wieder bei uns im Shop die Mehrwertsteuer holen mit der abgestempelten Originalrechnung. So sind
                        die 12% gespart.
                    </div>

                    <v-container class="width350 pb-2">
                        <v-layout row>
                            <v-flex xs6 class="pa-0">Beispiel:</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs9 class="pa-0">Grill inkl. Mwst.</v-flex> <v-flex xs3 lass="pa-0">€ 1200</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs9 class="pa-0">Grill exkl. Mwst.</v-flex><v-flex xs3 lass="pa-0"> € 1000</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs9 class="pa-0">Schweiz Steuer 8,1%</v-flex> <v-flex xs3 lass="pa-0">€ 81</v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs9><h4>Ersparnis</h4></v-flex> <v-flex xs3><h4>€ 119</h4></v-flex>
                        </v-layout>
                    </v-container>

                    <div class="pb-2 pa-0">
                        <v-btn
                            color="primary text-uppercase ma-0"
                            to="/infos-fuer-schweizer-kunden"
                        >
                            mehr Infos
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'InfoModal',
    props: ['show'],
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>

<style scoped>
.width350 {
    max-width: 350px;
    margin: 0;
    padding: 0;
}
@media(max-width: 350px) {
    .width350 {
        font-size: 14px;
    }
}
</style>
